module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms-brand/src/series/serie-list/serie-list.component.scss
// module id = ./libs/atenea-cms-brand/src/series/serie-list/serie-list.component.scss
// module chunks = main